import React, { useState } from 'react';
import css from './ReviewCard.module.css';
import { IconBrandCard } from '../../../../components';
import ReactStars from 'react-stars';
import { FormattedMessage } from 'react-intl';

function ReviewCard(props) {
  const { avatar, reviewerName, reviewDate, reviewDescription, rating, abbreviatedName } = props;

  const [showMore, setShowMore] = useState(false);
  const shouldTruncate = reviewDescription.length > 120;
  const displayedText =
    shouldTruncate && !showMore ? `${reviewDescription.substring(0, 120)}...` : reviewDescription;

  return (
    <div className={css.reviewCardWrapper}>
      <div className={css.reviewProfile}>
        {avatar ? (
          <img src={avatar} alt="Reviewer Avatar" />
        ) : (
          <span className={css.abbreviatedName}>{abbreviatedName}</span>
        )}
        <span>{reviewerName}</span>
      </div>
      <div className={css.reviewDate}>{reviewDate}</div>
      <ReactStars
        count={5}
        value={rating}
        onChange={() => {}}
        size={20}
        isHalf={true}
        edit={false}
        color1={'#ccc'}
        color2={'#000'}
      />
      <div className={css.reviewDescription}>
        {displayedText} &nbsp;
        {shouldTruncate && (
          <span className={css.showMore} onClick={() => setShowMore(!showMore)}>
            {showMore ? (
              <>
                <FormattedMessage id="ProfilePage.showLess" />
                <IconBrandCard type="toparrow" />
              </>
            ) : (
              <>
                <FormattedMessage id="ProfilePage.showMore" />
                <IconBrandCard type="bottomarrow" />
              </>
            )}
          </span>
        )}
      </div>
    </div>
  );
}

export default ReviewCard;
